






























import _ from 'lodash'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { TCWBadDataStructureError } from '@/plugins/TCWBaseError'
import * as ApiPath from '@/tcw/constant/ApiPath'
import { ERR_CODE_WEB_API_NOT_FOUND } from '@/tcw/constant/ErrorCode'
import Getsudo from '@/tcw/domain/Getsudo'
import { TcwAPIID } from '@/tcw/domain/types'
import { ApiErrorHandle, ApiGeneralObjectArrayPayload, ApiGeneralPayload } from '@/tcw/api/types'
import DataGetComponent from '@/tcw/components/DataGetComponent'
import ShouninActionExecInfo from '@/components/shounin/molecules/ShouninActionExecInfo.vue'

@Component({
  components: { ShouninActionExecInfo }
})
export default class ShouninRouteSteps extends Mixins(DataGetComponent) {
  @Prop({ required: true, default: -1 })
  protected userId!: TcwAPIID
  @Prop({ required: true, type: Getsudo, default: () => Getsudo.now() })
  protected getsudo!: Getsudo

  private shouninRirekiList: ApiGeneralObjectArrayPayload = []

  get apiPath(): string {
    return ApiPath.buildPath(ApiPath.Paths.ShouninRireki.get, {
      year: this.getsudo.yearValue,
      month: this.getsudo.monthValue,
      userId: `${this.userId}`
    })
  }

  get handleApiError(): ApiErrorHandle {
    return {
      [ERR_CODE_WEB_API_NOT_FOUND]: () => Promise.resolve(true)
    }
  }

  get shouninCommentCardStyle(): { [key: string]: string } {
    return { padding: '0.6rem 1rem' }
  }

  protected responseInitWebApi(response: ApiGeneralPayload): void {
    if (_.isArray(response)) {
      this.shouninRirekiList = response as ApiGeneralObjectArrayPayload
    } else {
      throw new TCWBadDataStructureError(
        'データ構造が不正です。システム管理者に問い合わせてください'
      )
    }
  }
}
